export enum ReasonOptionsDeleteComment {
  Unrelated = 'UNRELATED_TO_DISCUSSION',
  Bullying = 'BULLYING_OR_HARASSMENT',
  SensitiveContent = 'SENSITIVE_CONTENT',
  HateSpeech = 'HATE_SPEECH',
  Spam = 'SPAM',
  OtherSpecify = 'OTHER_SPECIFY',
}
